import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider } from '../http-interceptor/http-interceptor';
import { EventoAdversoModel } from '../../pages/evento-adverso/evento-adverso.modelview';

/*
  Generated class for the DocumentosProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AdverseEventsProvider {

    apiBase = baseUrlFunc() + "emailadversos/v1/rout"

    constructor(public http: HttpInterceptorProvider) {
    }

    sendAdverseEvents(event: EventoAdversoModel): Observable<any> {
        //Cloning Object
        let objString = JSON.stringify(event)
        let adverseEvent = JSON.parse(objString)

        adverseEvent.especialidades = undefined
        adverseEvent.estados = undefined
        adverseEvent.produtos = undefined

        return Observable.create(observer => {
            this.http.postQS(this.apiBase, adverseEvent).subscribe(data => {
                observer.next(data)
                console.log("sendAdverseEvents success response", data)
            }, err => {
                observer.error(err)
                console.log("sendAdverseEvents error response", err)
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/providers/adverses/adverses.ts